import Axios from "axios";
import { ProjectFolder } from "graphql/_Types";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";
import { HexColor } from "vega";

export type ProjectFolderDjango = {
  id: ProjectFolder["id"];
  name: ProjectFolder["name"];
  date_created: ProjectFolder["dateCreated"];
  user: ProjectFolder["userId"];
  project: ProjectFolder["projectId"];
  color: ProjectFolder["color"];
};

export const getProjectFolderDjango = async (folderId: ProjectFolder["id"]) => {
  const baseUrl = getEnvVar("URL_LIBRARY_PROJECT_FOLDER");
  const url = `${baseUrl}${String(folderId)}/`;
  const headers = await getRequestHeaders();
  const { data } = await Axios.get<ProjectFolderDjango>(url, { headers });
  return data;
};

export const getProjectFoldersDjango = async (
  projectId: ProjectFolder["projectId"],
) => {
  const baseUrl = getEnvVar("URL_LIBRARY_PROJECT_FOLDER");
  const url = `${baseUrl}?project=${projectId}`;
  const headers = await getRequestHeaders();
  const { data } = await Axios.get<ProjectFolderDjango[]>(url, { headers });
  return data.filter((folder) => folder.project === projectId);
};

export const createProjectFolderDjango = async (
  folderName: string,
  projectId: ProjectFolder["projectId"],
  color: HexColor | null,
) => {
  const baseUrl = getEnvVar("URL_LIBRARY_PROJECT_FOLDER");
  const url = baseUrl;
  const headers = await getRequestHeaders();
  const { data } = await Axios.post<ProjectFolderDjango>(
    url,
    {
      name: folderName,
      project: projectId,
      color,
    },
    { headers },
  );
  return data;
};

export const deleteProjectFolderDjango = async (
  folderId: ProjectFolder["id"],
) => {
  const baseUrl = getEnvVar("URL_LIBRARY_PROJECT_FOLDER");
  const url = `${baseUrl}${String(folderId)}/`;
  const headers = await getRequestHeaders();
  await Axios.delete(url, { headers });
};

export const updateProjectFolderDjango = async (
  folderId: ProjectFolder["id"],
  folderName: string,
  color: HexColor | null,
) => {
  const baseUrl = getEnvVar("URL_LIBRARY_PROJECT_FOLDER");
  const url = `${baseUrl}${String(folderId)}/`;
  const headers = await getRequestHeaders();
  const { data } = await Axios.patch<ProjectFolderDjango>(
    url,
    {
      name: folderName,
      color,
    },
    { headers },
  );
  return data;
};
